import { ProductsService } from './service.js';

export const G__ProductsModule = {
    ProductsService
};
